@import '../vars.css';

.size-32 {
    border-radius: var(--button-xxs-size-mobile-border-radius);
}

.size-40 {
    border-radius: var(--button-xs-size-mobile-border-radius);
}

.size-48 {
    border-radius: var(--button-s-size-mobile-border-radius);
}

.size-56 {
    border-radius: var(--button-m-size-mobile-border-radius);
}

.size-64 {
    border-radius: var(--button-l-size-mobile-border-radius);
}

.size-72 {
    border-radius: var(--button-xl-size-mobile-border-radius);
}
